/**
 * RPDM W1-D · Widget-framework primitive (structural shell only).
 *
 * SCOPE: A pure layout wrapper. Renders a titled card with a body slot.
 * NO business logic, NO data fetching, NO chart libs, NO Gantt, NO
 * reporting integration.
 *
 * Reserved for W2+ when actual widget content (rollups, activity feed,
 * milestone list, etc.) will be filled in behind their own feature
 * flags.
 */
export default function WorkspaceWidgetShell({
    title,
    description,
    children,
    testId,
    footer,
}) {
    return (
        <section
            data-testid={testId || "rpdm-workspace-widget"}
            className="rounded-lg border border-slate-200 bg-white shadow-sm"
        >
            <header className="border-b border-slate-100 px-4 py-3">
                <h3
                    data-testid={testId ? `${testId}-title` : "rpdm-workspace-widget-title"}
                    className="text-sm font-semibold text-slate-900"
                >
                    {title}
                </h3>
                {description ? (
                    <p className="mt-1 text-xs text-slate-500">{description}</p>
                ) : null}
            </header>
            <div className="px-4 py-3 text-sm text-slate-700">{children}</div>
            {footer ? (
                <footer className="border-t border-slate-100 px-4 py-2 text-xs text-slate-500">
                    {footer}
                </footer>
            ) : null}
        </section>
    );
}
